var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"privilege-tree"},[_c('el-tree',{ref:"privilegeTree",attrs:{"data":_vm.treeData,"props":_vm.defaultProps,"show-checkbox":"","node-key":"id","default-expanded-keys":_vm.expandedKeys,"default-checked-keys":_vm.checkedKeys},on:{"check":_vm.handleCheckChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }